import { render, staticRenderFns } from "./ModalYoutube.vue?vue&type=template&id=de06b634&scoped=true"
import script from "./ModalYoutube.vue?vue&type=script&lang=js"
export * from "./ModalYoutube.vue?vue&type=script&lang=js"
import style0 from "./ModalYoutube.vue?vue&type=style&index=0&id=de06b634&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de06b634",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de06b634')) {
      api.createRecord('de06b634', component.options)
    } else {
      api.reload('de06b634', component.options)
    }
    module.hot.accept("./ModalYoutube.vue?vue&type=template&id=de06b634&scoped=true", function () {
      api.rerender('de06b634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalYoutube.vue"
export default component.exports